/**
 * NH PDP Bundle Cards - JavaScript
 * Version: 2.0
 * 
 * Hauptfunktionen:
 * - Bundle-Card Selection & Highlighting
 * - Preis-Updates basierend auf Menge und Rabatt
 * - Integration mit Seal Subscriptions
 * - Automatische Vorauswahl von Menge 1
 */

(function() {
  'use strict';

  function q(selector, parent) {
    return (parent || document).querySelector(selector);
  }

  function qq(selector, parent) {
    return (parent || document).querySelectorAll(selector);
  }

  function isPdpBundleBVariant() {
    return document.documentElement.classList.contains('abx-pdp-bundle-b') ||
      document.body.classList.contains('abx-pdp-bundle-b');
  }

  let deliveryLabelUid = 0;
  const FOCUSABLE_SELECTOR = 'a[href], button, input, select, textarea, summary, [tabindex]:not([tabindex="-1"]), [contenteditable="true"]';

  function setTreeFocusable(root, isFocusable) {
    if (!root) return;

    const focusableElements = qq(FOCUSABLE_SELECTOR, root);
    focusableElements.forEach(function(element) {
      if (!isFocusable) {
        if (!element.hasAttribute('data-nh-bqs-tabindex')) {
          element.setAttribute('data-nh-bqs-tabindex', element.getAttribute('tabindex') || '');
        }
        element.setAttribute('tabindex', '-1');
        return;
      }

      if (!element.hasAttribute('data-nh-bqs-tabindex')) return;

      const originalTabindex = element.getAttribute('data-nh-bqs-tabindex');
      if (originalTabindex) {
        element.setAttribute('tabindex', originalTabindex);
      } else {
        element.removeAttribute('tabindex');
      }
      element.removeAttribute('data-nh-bqs-tabindex');
    });
  }

  function setHiddenTree(root, isHidden) {
    if (!root) return;

    if (isHidden) {
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('inert', '');
      setTreeFocusable(root, false);
      return;
    }

    root.removeAttribute('aria-hidden');
    root.removeAttribute('inert');
    setTreeFocusable(root, true);
  }

  function isHiddenElement(element) {
    if (!element) return false;
    const style = window.getComputedStyle(element);
    return element.hidden || style.display === 'none' || style.visibility === 'hidden';
  }

  function syncSealsubsAccessibility() {
    qq('.sealsubs-container').forEach(function(container) {
      const isHiddenWidget = container.classList.contains('nh-pdp-bundle-cards__hidden-widget') || isHiddenElement(container);
      setHiddenTree(container, isHiddenWidget);
    });

    qq('.sls-option-container').forEach(function(container) {
      const parentWidget = container.closest('.sealsubs-container');
      if (parentWidget && (parentWidget.classList.contains('nh-pdp-bundle-cards__hidden-widget') || isHiddenElement(parentWidget))) return;

      if (!isHiddenElement(container)) {
        setHiddenTree(container, false);
      }
    });

    qq('.sls-more-info-container, .sls-selling-plan-group-options, .sls-total-price, .sls-selling-plan-group-price, .sls-price-container, .nh-pdp-bundle-cards__selling-plan-group-dropdown').forEach(function(container) {
      if (isHiddenElement(container)) {
        setHiddenTree(container, true);
      }
    });
  }

  function syncDeliveryLabelAccessibility() {
    qq('.nh-pdp-bundle-cards__sealsubs-wrapper').forEach(function(wrapper) {
      const label = q('.sls-purchase-options-label', wrapper);
      const optionsContainer = q('.sls-purchase-options-container', wrapper);
      if (!label || !optionsContainer) return;

      const previousLabelId = label.id;
      let labelId = wrapper.getAttribute('data-nh-bqs-delivery-label-id');

      if (!labelId || (document.getElementById(labelId) && document.getElementById(labelId) !== label)) {
        do {
          deliveryLabelUid += 1;
          labelId = `nh-bqs-delivery-label-${Date.now().toString(36)}-${deliveryLabelUid}`;
        } while (document.getElementById(labelId));
        wrapper.setAttribute('data-nh-bqs-delivery-label-id', labelId);
      }

      label.id = labelId;

      const outerRadiogroup = optionsContainer.parentElement ? optionsContainer.parentElement.closest('[role="radiogroup"]') : null;
      const labelledGroup = outerRadiogroup || optionsContainer;

      if (outerRadiogroup) {
        if (optionsContainer.getAttribute('role') === 'radiogroup') {
          optionsContainer.removeAttribute('role');
        }
      } else if (q('.sls-option[type="radio"]', optionsContainer)) {
        labelledGroup.setAttribute('role', 'radiogroup');
      } else {
        labelledGroup.setAttribute('role', 'group');
      }
      labelledGroup.setAttribute('aria-labelledby', labelId);

      qq('[aria-labelledby]', wrapper).forEach(function(element) {
        const labelledBy = element.getAttribute('aria-labelledby');
        if (!labelledBy) return;

        const ids = labelledBy.split(/\s+/).filter(Boolean);
        const referencesDeliveryLabel = ids.some(function(id) {
          return id === 'seal-purchase-options-label' || id === previousLabelId || id.indexOf('nh-bqs-delivery-label-') === 0;
        });

        if (outerRadiogroup && element === optionsContainer) {
          if (referencesDeliveryLabel) {
            element.removeAttribute('aria-labelledby');
          }
          return;
        }

        if (referencesDeliveryLabel || element.getAttribute('role') === 'radiogroup') {
          element.setAttribute('aria-labelledby', labelId);
        }
      });

      syncDeliveryOptionAccessibility(wrapper);
    });
  }

  function getDeliveryOptionContainers(wrapper) {
    return Array.from(qq('.sls-option-container', wrapper)).filter(function(container) {
      return !isHiddenElement(container) && q('.sls-option[type="radio"]', container);
    });
  }

  function getDeliveryOptionRadio(container) {
    return q('.sls-option[type="radio"]', container);
  }

  function getDeliveryOptionLabel(container) {
    const title = q('.nh-pdp-bundle-cards__selling-plan-group-title, .sls-selling-plan-group-name, .sls-selling-plan-group-first-line', container);
    const subtitle = q('.nh-pdp-bundle-cards__selling-plan-group-subtitle', container);
    const parts = [];

    if (title && title.textContent.trim()) {
      parts.push(title.textContent.trim());
    }

    if (subtitle && subtitle.textContent.trim()) {
      parts.push(subtitle.textContent.trim());
    }

    return parts.length ? parts.join(', ').replace(/\s+/g, ' ') : (container.textContent || '').trim().replace(/\s+/g, ' ');
  }

  function syncDeliveryOptionAccessibility(wrapper) {
    const optionContainers = getDeliveryOptionContainers(wrapper || document);
    if (!optionContainers.length) return;

    let checkedIndex = optionContainers.findIndex(function(container) {
      const radio = getDeliveryOptionRadio(container);
      return (radio && radio.checked) || container.classList.contains('sls-active');
    });

    if (checkedIndex < 0) checkedIndex = 0;

    optionContainers.forEach(function(container, index) {
      const radio = getDeliveryOptionRadio(container);
      const isChecked = index === checkedIndex;

      container.setAttribute('role', 'radio');
      container.setAttribute('aria-checked', isChecked ? 'true' : 'false');
      container.setAttribute('tabindex', isChecked ? '0' : '-1');

      const label = getDeliveryOptionLabel(container);
      if (label) {
        container.setAttribute('aria-label', label);
      }

      if (radio) {
        radio.setAttribute('tabindex', '-1');
      }
    });
  }

  function activateDeliveryOption(container, shouldFocus) {
    if (!container) return;

    const radio = getDeliveryOptionRadio(container);
    if (radio && !radio.checked) {
      radio.click();
    } else {
      container.click();
    }

    const wrapper = container.closest('.nh-pdp-bundle-cards__sealsubs-wrapper') || document;

    setTimeout(function() {
      syncDeliveryOptionAccessibility(wrapper);
      toggleAboDropdown();
      updateInfoboxVisibility();
      changeTotal();
      changeDiscount();
      handlePriceUpdate();

      if (shouldFocus) {
        container.focus({ preventScroll: true });
      }
    }, 0);
  }

  function initDeliveryOptionsKeyboard() {
    qq('.nh-pdp-bundle-cards__sealsubs-wrapper').forEach(function(wrapper) {
      const optionContainers = getDeliveryOptionContainers(wrapper);
      if (!optionContainers.length) return;

      syncDeliveryOptionAccessibility(wrapper);

      optionContainers.forEach(function(container) {
        if (container.getAttribute('data-nh-bqs-delivery-radio-ready') === 'true') return;
        container.setAttribute('data-nh-bqs-delivery-radio-ready', 'true');

        container.addEventListener('click', function() {
          setTimeout(function() {
            syncDeliveryOptionAccessibility(wrapper);
          }, 0);
        });

        container.addEventListener('keydown', function(event) {
          const currentOptions = getDeliveryOptionContainers(wrapper);
          const currentIndex = currentOptions.indexOf(container);
          let nextIndex = currentIndex;

          switch (event.key) {
            case 'ArrowRight':
            case 'ArrowDown':
              event.preventDefault();
              nextIndex = (currentIndex + 1) % currentOptions.length;
              activateDeliveryOption(currentOptions[nextIndex], true);
              break;
            case 'ArrowLeft':
            case 'ArrowUp':
              event.preventDefault();
              nextIndex = (currentIndex - 1 + currentOptions.length) % currentOptions.length;
              activateDeliveryOption(currentOptions[nextIndex], true);
              break;
            case 'Home':
              event.preventDefault();
              activateDeliveryOption(currentOptions[0], true);
              break;
            case 'End':
              event.preventDefault();
              activateDeliveryOption(currentOptions[currentOptions.length - 1], true);
              break;
            case 'Enter':
            case ' ':
              event.preventDefault();
              activateDeliveryOption(container, true);
              break;
            default:
              break;
          }
        });
      });
    });
  }

  function revealSealsubsWrapper() {
    const wrapper = q('.nh-pdp-bundle-cards__sealsubs-wrapper');
    if (!wrapper) return;
    wrapper.classList.remove('nh-bqs__sealsubs-loading');
    wrapper.setAttribute('data-sealsubs-ready', 'true');
  }

  function revealSealsubsWhenCustomized() {
    const wrapper = q('.nh-pdp-bundle-cards__sealsubs-wrapper');
    if (!wrapper || wrapper.getAttribute('data-sealsubs-ready') === 'true') return;

    poll(
      () => q('.nh-pdp-bundle-cards__selling-plan-group-first-line, .nh-pdp-bundle-cards__selling-plan-group-second-line', wrapper),
      () => {
        syncSealsubsAccessibility();
        syncDeliveryLabelAccessibility();
        initDeliveryOptionsKeyboard();
        revealSealsubsWrapper();
      },
      20
    );

    setTimeout(revealSealsubsWrapper, 2200);
  }

  function poll(checkFn, callback, maxAttempts = 50) {
    let attempts = 0;
    const interval = setInterval(() => {
      attempts++;
      const result = checkFn();
      if (result || attempts >= maxAttempts) {
        clearInterval(interval);
        if (result) callback(result);
      }
    }, 100);
  }

  /**
   * SealSubs: Abo aktiv wenn eine Option mit selling-plan-group (nicht 0/leer) .sls-active ist.
   */
  function isSubscriptionOptionActive() {
    if (!q('.sealsubs-container')) return false;
    if (q('.sls-option-container.seal-table[data-selling-plan-group].sls-active')) return true;
    var nodes = qq('.sls-option-container[data-selling-plan-group].sls-active');
    for (var i = 0; i < nodes.length; i++) {
      var g = nodes[i].getAttribute('data-selling-plan-group');
      if (g && g !== '0') return true;
    }
    return false;
  }


  function changeHTML(element, html) {
    if (element) element.innerHTML = html;
  }

  function priceToNumber(priceString) {
    if (!priceString) return 0;
    const cleanedPrice = priceString.replace(/[€$£\s]/g, '').replace(',', '.');
    return parseFloat(cleanedPrice) || 0;
  }

  function numberToPrice(number) {
    return `€${number.toFixed(2).replace('.', ',')}`;
  }


  function ensureQuantityInput() {
    let quantityInput = q('.product__quantity input.js-qty__num') || 
                        q('.product__quantity input') || 
                        q('input[name="quantity"]');
    
    if (quantityInput) {
      return quantityInput;
    }
    
    const productForm = q('.product-single__form, form[action*="/cart/add"], .product-form, [data-product-form]');
    if (!productForm) {
      return null;
    }
    
    const wrapper = document.createElement('div');
    wrapper.className = 'product__quantity';
    wrapper.style.cssText = 'position: absolute; width: 1px; height: 1px; overflow: hidden; clip: rect(0,0,0,0);';
    
    const input = document.createElement('input');
    input.type = 'text';
    input.name = 'quantity';
    input.value = '1';
    input.min = '1';
    input.className = 'js-qty__num nh-bqs__quantity-input';
    input.setAttribute('aria-label', 'quantity');
    input.setAttribute('pattern', '[0-9]*');
    wrapper.appendChild(input);
    productForm.insertBefore(wrapper, productForm.firstChild);
    return input;
  }


  function scrollToSelectedCard(card) {
    if (!card) return;
    
    const scrollContainer = card.closest('.nh-bqs__bundle-cards');
    if (!scrollContainer) return;
    
    const cardRect = card.getBoundingClientRect();
    const containerRect = scrollContainer.getBoundingClientRect();
    const scrollLeft = scrollContainer.scrollLeft;
    
    // Berechne die Position der Card relativ zum Container
    const cardLeft = cardRect.left - containerRect.left + scrollLeft;
    const cardWidth = cardRect.width;
    const containerWidth = containerRect.width;
    
    // Berechne die gewünschte Scroll-Position (Card zentriert oder am Rand)
    const cardCenter = cardLeft + (cardWidth / 2);
    const containerCenter = scrollLeft + (containerWidth / 2);
    
    // Scroll nur wenn die Card nicht vollständig sichtbar ist
    const isFullyVisible = cardLeft >= scrollLeft && 
                           (cardLeft + cardWidth) <= (scrollLeft + containerWidth);
    
    if (!isFullyVisible) {
      // Scroll zur Card mit etwas Padding
      const targetScroll = cardLeft - (containerWidth / 2) + (cardWidth / 2);
      
      scrollContainer.scrollTo({
        left: targetScroll,
        behavior: 'smooth'
      });
    }
  }

  function initBundleCardsHandlers() {
    const bundleCards = Array.from(qq('.nh-bqs__bundle-card'));
    let quantityInput = ensureQuantityInput();
    
    if (bundleCards.length === 0) {
      if (quantityInput) {
        quantityInput.value = 1;
      }
      return;
    }

    function getSelectedCard() {
      return q('.nh-bqs__bundle-card.selected') || q('.nh-bqs__bundle-card[aria-checked="true"]');
    }

    function setBundleCardState(card, isSelected) {
      card.removeAttribute('selected');
      card.setAttribute('role', 'radio');
      card.setAttribute('aria-checked', isSelected ? 'true' : 'false');
      card.setAttribute('tabindex', isSelected ? '0' : '-1');
      card.classList.toggle('selected', isSelected);
    }

    function syncQuantityInputs(quantity, productQuantityInput, shouldDispatchEvents) {
      if (productQuantityInput) {
        productQuantityInput.value = quantity;

        if (shouldDispatchEvents) {
          productQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
          productQuantityInput.dispatchEvent(new Event('input', { bubbles: true }));
          productQuantityInput.dispatchEvent(new Event('blur', { bubbles: true }));
        }
      }

      if (quantityInput && quantityInput !== productQuantityInput) {
        quantityInput.value = quantity;

        if (shouldDispatchEvents) {
          quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      qq('input[name="quantity"]').forEach(function(input) {
        if (input !== quantityInput && input !== productQuantityInput) {
          input.value = quantity;
        }
      });
    }

    function selectBundleCard(card, options) {
      if (!card) return false;

      const settings = Object.assign({
        updateInputs: true,
        dispatchEvents: true,
        focus: false,
        scroll: true,
        updatePricing: true
      }, options || {});

      bundleCards.forEach(function(currentCard) {
        setBundleCardState(currentCard, currentCard === card);
      });

      if (settings.focus) {
        card.focus({ preventScroll: true });
      }

      if (settings.scroll) {
        scrollToSelectedCard(card);
      }

      if (settings.updateInputs) {
        const quantity = card.getAttribute('data-quantity') || '1';
        syncQuantityInputs(quantity, ensureQuantityInput(), settings.dispatchEvents);
      }

      if (settings.updatePricing) {
        changeTotal();
        changeDiscount();

        setTimeout(function() {
          handlePriceUpdate();
          changeTotal();
          changeDiscount();
        }, 50);
      }

      return true;
    }
    
    function highlightMatchingCard(quantity) {
      const currentQty = parseInt(quantity) || 1;
      const selectedCard = bundleCards.find(function(card) {
        const cardQty = parseInt(card.getAttribute('data-quantity')) || 0;
        return cardQty === currentQty;
      });

      if (!selectedCard) return false;

      selectBundleCard(selectedCard, {
        updateInputs: false,
        dispatchEvents: false,
        focus: false,
        scroll: true,
        updatePricing: false
      });

      return true;
    }
    
    if (quantityInput) {
      quantityInput.value = 1;
      
      const success = highlightMatchingCard(1);
      
      if (!success) {
        const card1 = Array.from(bundleCards).find(c => c.getAttribute('data-quantity') === '1');
        if (card1) {
          selectBundleCard(card1, {
            updateInputs: false,
            dispatchEvents: false,
            focus: false,
            scroll: false,
            updatePricing: false
          });
          setTimeout(() => {
            scrollToSelectedCard(card1);
          }, 100);
        } else {
          selectBundleCard(bundleCards[0], {
            updateInputs: false,
            dispatchEvents: false,
            focus: false,
            scroll: true,
            updatePricing: false
          });
        }
      }
      
      changeTotal();
      changeDiscount();
      
      setTimeout(function() {
        highlightMatchingCard(1);
        changeTotal();
        changeDiscount();
        handlePriceUpdate();
      }, 50);
      
      setTimeout(function() {
        highlightMatchingCard(1);
        changeTotal();
        changeDiscount();
        const selectedCard = getSelectedCard();
        if (selectedCard) {
          scrollToSelectedCard(selectedCard);
        }
      }, 300);
    }
    
    const productQuantityInput = ensureQuantityInput();
    if (productQuantityInput && productQuantityInput !== quantityInput) {
      
      ['input', 'change'].forEach(function(eventType) {
        productQuantityInput.addEventListener(eventType, function() {
          highlightMatchingCard(productQuantityInput.value);
        });
      });
    }
    
    if (quantityInput) {
      ['input', 'change'].forEach(function(eventType) {
        quantityInput.addEventListener(eventType, function() {
          highlightMatchingCard(quantityInput.value);
        });
      });
      
      document.addEventListener('click', function(e) {
        const target = e.target.closest('button');
        if (target) {
          const isQuantityButton = target.closest('.product__quantity') || 
                                   target.closest('.quantity-input') || 
                                   target.closest('.quantity') ||
                                   target.hasAttribute('data-quantity-minus') ||
                                   target.hasAttribute('data-quantity-plus') ||
                                   target.name === 'minus' ||
                                   target.name === 'plus';
          
          if (isQuantityButton) {
            setTimeout(function() {
              const currentInput = ensureQuantityInput();
              const currentValue = currentInput ? currentInput.value : quantityInput.value;
              highlightMatchingCard(currentValue);
            }, 100);
          }
        }
      });
      
      let lastValue = quantityInput.value;
      setInterval(function() {
        const currentInput = ensureQuantityInput();
        const currentValue = currentInput ? currentInput.value : quantityInput.value;
        
        if (currentValue !== lastValue) {
          lastValue = currentValue;
          highlightMatchingCard(currentValue);
        }
      }, 500);
    }
    
    bundleCards.forEach(function(card) {
      setBundleCardState(card, card.classList.contains('selected') || card.getAttribute('aria-checked') === 'true');

      if (card.getAttribute('data-nh-bqs-radio-ready') === 'true') return;
      card.setAttribute('data-nh-bqs-radio-ready', 'true');

      card.addEventListener('click', function() {
        selectBundleCard(card, { focus: false });
      });

      card.addEventListener('keydown', function(event) {
        const currentIndex = bundleCards.indexOf(card);
        let nextIndex = currentIndex;

        switch (event.key) {
          case 'ArrowRight':
          case 'ArrowDown':
            event.preventDefault();
            nextIndex = (currentIndex + 1) % bundleCards.length;
            selectBundleCard(bundleCards[nextIndex], { focus: true });
            break;
          case 'ArrowLeft':
          case 'ArrowUp':
            event.preventDefault();
            nextIndex = (currentIndex - 1 + bundleCards.length) % bundleCards.length;
            selectBundleCard(bundleCards[nextIndex], { focus: true });
            break;
          case 'Home':
            event.preventDefault();
            selectBundleCard(bundleCards[0], { focus: true });
            break;
          case 'End':
            event.preventDefault();
            selectBundleCard(bundleCards[bundleCards.length - 1], { focus: true });
            break;
          case 'Enter':
          case ' ':
            event.preventDefault();
            selectBundleCard(card, { focus: true });
            break;
          default:
            break;
        }
      });
    });

    if (!getSelectedCard()) {
      selectBundleCard(bundleCards[0], {
        updateInputs: false,
        dispatchEvents: false,
        focus: false,
        scroll: false,
        updatePricing: false
      });
    }
  }

  function syncSavePercentBadges() {
    const totalPriceContainer = q(".nh-bqs__total-price");
    if (!totalPriceContainer) return;
    const refC = parseInt(totalPriceContainer.getAttribute("data-pricing-ref-cents"), 10);
    const finC = parseInt(totalPriceContainer.getAttribute("data-pricing-final-cents"), 10);
    let pct = 0;
    if (!isNaN(refC) && !isNaN(finC) && refC > 0 && finC < refC) {
      pct = Math.round(((refC - finC) * 100) / refC);
    }
    const savedAmountElement = q(".nh-bqs__total-price-save");
    if (savedAmountElement) {
      if (pct > 0) {
        savedAmountElement.setAttribute("data-visible", "true");
        changeHTML(savedAmountElement, `(Du sparst ${pct}%)`);
      } else {
        savedAmountElement.setAttribute("data-visible", "false");
        changeHTML(savedAmountElement, "");
      }
    }
    const pdpSaveInner = document.querySelector("[data-bundle-coupled-save] .bundle-pdp-save");
    const pdpSaveWrap = document.querySelector("[data-bundle-coupled-save]");
    if (pdpSaveInner && pdpSaveWrap) {
      if (pct > 0) {
        pdpSaveWrap.classList.remove("hide");
        changeHTML(pdpSaveInner, `(Du sparst ${pct}%)`);
      } else {
        pdpSaveWrap.classList.add("hide");
        changeHTML(pdpSaveInner, "");
      }
    }
  }

  function changeTotal() {
    poll(
      () => q(".nh-bqs__total-price"),
      () => {
        const selectedCard = q(".nh-bqs__bundle-card.selected");
        if (!selectedCard) {
          return;
        }
        
        const quantity = parseInt(selectedCard.getAttribute("data-quantity")) || 1;
        const bundleDiscount = parseFloat(selectedCard.getAttribute("data-discount")) || 0;
        
        
        const totalPriceContainer = q(".nh-bqs__total-price");
        if (!totalPriceContainer) return;
        
        const initialQuantity = parseInt(totalPriceContainer.getAttribute("data-initial-quantity")) || 1;
        
        const baseVariantCents = parseInt(totalPriceContainer.getAttribute("data-base-variant-unit-cents"), 10);
        let originalUnitPrice;
        if (!isNaN(baseVariantCents) && baseVariantCents > 0) {
          originalUnitPrice = baseVariantCents / 100;
        } else {
          const originalPriceElement = q('.nh-bqs__bundle-card[data-quantity="1"][data-discount="0"] .nh-bqs__bundle-card-unit-price-value');
          if (!originalPriceElement) {
            return;
          }
          originalUnitPrice = priceToNumber(originalPriceElement.textContent);
        }
        
        const compareAtPriceCents = parseInt(totalPriceContainer.getAttribute("data-compare-at-price")) || 0;
        const compareAtPrice = compareAtPriceCents / 100;

        const compareReferenceTotal =
          compareAtPrice > originalUnitPrice
            ? compareAtPrice * quantity
            : originalUnitPrice * quantity;
        
        const hasSealSubscriptions = q(".sealsubs-container") !== null;
        
        let isAboActive = false;
        if (hasSealSubscriptions) {
          isAboActive = isSubscriptionOptionActive();
        }
        
        let aboDiscount = 0;
        if (isAboActive) {
          const aboBadge = q(".sls-option-container.sls-active .nh-pdp-bundle-cards__selling-plan-group-percentage, .sls-option-container.sls-active [data-discount], .sls-option-container.sls-active .sls-discount-badge");
          if (aboBadge) {
            const discountValue = aboBadge.getAttribute('data-discount') || aboBadge.textContent;
            const discountMatch = discountValue.match(/(\d+(?:\.\d+)?)/);
            if (discountMatch) {
              aboDiscount = parseFloat(discountMatch[1]);
            }
          }
          if (aboDiscount === 0) {
            aboDiscount = 15;
          }
        }
        
        let finalUnitPrice;
        let effectiveDiscount;
        let comparePrice;
        let discountedPrice;
        
        if (isAboActive && aboDiscount > 0) {
          const aboFactor = 1 - aboDiscount / 100;
          
          const originalPriceInCents = Math.round(originalUnitPrice * 100);
          const unitPriceInCents = Math.round(originalPriceInCents * aboFactor);
          finalUnitPrice = unitPriceInCents / 100;
          
          const totalPriceInCents = unitPriceInCents * quantity;
          discountedPrice = totalPriceInCents / 100;
          
          effectiveDiscount = aboDiscount;
          comparePrice = compareReferenceTotal;
          
        } else {
          const bundleFactor = bundleDiscount > 0 ? (1 - bundleDiscount / 100) : 1;
          
          const originalPriceInCents = Math.round(originalUnitPrice * 100);
          
          const unitPriceInCents = Math.round(originalPriceInCents * bundleFactor);
          finalUnitPrice = unitPriceInCents / 100;
          
          const exactUnitPriceInCents = originalPriceInCents * bundleFactor;
          const exactTotalInCents = exactUnitPriceInCents * quantity;
          const totalPriceInCents = Math.ceil(exactTotalInCents);
          discountedPrice = totalPriceInCents / 100;
          
          effectiveDiscount = bundleDiscount;
          comparePrice = compareReferenceTotal;
          
        }
        
        const quantitySpan = totalPriceContainer.querySelector('[data-total-quantity]');
        if (quantitySpan) {
          quantitySpan.textContent = quantity;
        }
        
        const totalPriceSpan = totalPriceContainer.querySelector('[data-total-price]');
        const comparePriceSpan = totalPriceContainer.querySelector('[data-compare-price]');
        const priceValueItem = totalPriceContainer.querySelector('.nh-bqs__total-price-value-item');
        
        if (totalPriceSpan) {
          totalPriceSpan.textContent = numberToPrice(discountedPrice);
        }
        
        if (priceValueItem) {
          const priceValueElement = priceValueItem.querySelector('.nh-bqs__total-price-value');
          if (priceValueElement) {
            let displayComparePrice = 0;
            if (effectiveDiscount > 0) {
              displayComparePrice = comparePrice;
            } else if (compareAtPrice > originalUnitPrice) {
              displayComparePrice = compareAtPrice * quantity;
            }
            
            if (displayComparePrice > discountedPrice) {
              if (!comparePriceSpan) {
                const comparePriceEl = document.createElement('span');
                comparePriceEl.className = 'nh-bqs__total-price-compare-value';
                comparePriceEl.setAttribute('data-compare-price', '');
                comparePriceEl.textContent = numberToPrice(displayComparePrice);
                priceValueElement.appendChild(comparePriceEl);
              } else {
                comparePriceSpan.textContent = numberToPrice(displayComparePrice);
              }
            } else {
              if (comparePriceSpan) {
                comparePriceSpan.remove();
              }
            }
          }
        }
        
        const unitPriceWrapper = totalPriceContainer.querySelector('[data-unit-price-wrapper]');
        if (unitPriceWrapper) {
          const unitPriceSpan = unitPriceWrapper.querySelector('span[data-unit-price]');
          const baseUnitPriceCents = parseInt(unitPriceWrapper.getAttribute('data-base-unit-price-cents'));
          
          if (unitPriceSpan && !isNaN(baseUnitPriceCents)) {
            const baseUnitPrice = baseUnitPriceCents / 100;
            
            let adjustedBaseUnitPrice;
            
            if (isAboActive && aboDiscount > 0) {
              adjustedBaseUnitPrice = Math.round(baseUnitPrice * (1 - aboDiscount / 100) * 100) / 100;
            } else {
              const discountFactor = bundleDiscount > 0 ? (1 - bundleDiscount / 100) : 1;
              adjustedBaseUnitPrice = Math.round(baseUnitPrice * discountFactor * 100) / 100;
            }
            
            unitPriceSpan.textContent = numberToPrice(adjustedBaseUnitPrice);
          }
        }

        var bundlePdpSync = document.querySelector('[data-bundle-price-sync-root]');
        if (bundlePdpSync) {
          var mainPriceEl = bundlePdpSync.querySelector('[data-bundle-price-coupled]');
          if (mainPriceEl) {
            mainPriceEl.textContent = numberToPrice(discountedPrice);
            var displayComparePdp = 0;
            if (effectiveDiscount > 0) {
              displayComparePdp = comparePrice;
            } else if (compareAtPrice > originalUnitPrice) {
              displayComparePdp = compareAtPrice * quantity;
            }
            if (displayComparePdp > discountedPrice) {
              mainPriceEl.classList.add('on-sale');
            } else {
              mainPriceEl.classList.remove('on-sale');
            }
          }
          var mainCompareEl = bundlePdpSync.querySelector('[data-bundle-compare-coupled]');
          var mainWrap = bundlePdpSync.querySelector('[data-product-price-wrap]');
          var displayCompareSync = 0;
          if (effectiveDiscount > 0) {
            displayCompareSync = comparePrice;
          } else if (compareAtPrice > originalUnitPrice) {
            displayCompareSync = compareAtPrice * quantity;
          }
          if (mainCompareEl && mainWrap) {
            if (displayCompareSync > discountedPrice) {
              mainCompareEl.textContent = numberToPrice(displayCompareSync);
              mainWrap.classList.remove('hide');
            } else {
              mainCompareEl.textContent = '';
              mainWrap.classList.add('hide');
            }
          }

          var pdpUnitWrapTop = bundlePdpSync.querySelector('[data-unit-price-wrapper]');
          if (pdpUnitWrapTop) {
            var pdpUnitCoupled = pdpUnitWrapTop.querySelector('[data-bundle-unit-coupled]');
            var baseCentsTop = parseInt(pdpUnitWrapTop.getAttribute('data-base-unit-price-cents'), 10);
            if (pdpUnitCoupled && !isNaN(baseCentsTop) && baseCentsTop > 0) {
              var baseUnitTop = baseCentsTop / 100;
              var adjustedTop;
              if (isAboActive && aboDiscount > 0) {
                adjustedTop = Math.round(baseUnitTop * (1 - aboDiscount / 100) * 100) / 100;
              } else {
                var dfTop = bundleDiscount > 0 ? (1 - bundleDiscount / 100) : 1;
                adjustedTop = Math.round(baseUnitTop * dfTop * 100) / 100;
              }
              pdpUnitCoupled.textContent = numberToPrice(adjustedTop);
            }
          }
        }

        const refCentsInt = Math.round(compareReferenceTotal * 100);
        const finCentsInt = Math.round(discountedPrice * 100);
        totalPriceContainer.setAttribute("data-pricing-ref-cents", String(refCentsInt));
        totalPriceContainer.setAttribute("data-pricing-final-cents", String(finCentsInt));
        syncSavePercentBadges();
        
      }
    );
  }

  function changeDiscount() {
    poll(
      () => {
        const selectedCard = q(".nh-bqs__bundle-card.selected");
        const savedAmountElement = q(`.nh-bqs__total-price-save`);
        return selectedCard && savedAmountElement;
      },
      () => {
        syncSavePercentBadges();
      }
    );
  }

  function updateOptionPrice(container, priceText) {
    if (!container) return;
    var priceEl = q(".nh-bqs__option-price", container);
    if (!priceEl) {
      priceEl = document.createElement('span');
      priceEl.className = 'nh-bqs__option-price';
      container.appendChild(priceEl);
      container.style.position = 'relative';
    }
    changeHTML(priceEl, priceText);
  }

  function updateBundleCardUnitPrices(baseUnitPrice, aboContainer) {
    const totalPriceContainer = q(".nh-bqs__total-price");
    const baseVariantCents = totalPriceContainer ? parseInt(totalPriceContainer.getAttribute("data-base-variant-unit-cents"), 10) : 0;
    const baseUnitPriceCents = baseVariantCents > 0 ? baseVariantCents : Math.round(baseUnitPrice * 100);
    const isAboActive = aboContainer && aboContainer.classList.contains("sls-active");
    const aboFactor = isAboActive ? 0.85 : 1;

    qq(".nh-bqs__bundle-card").forEach(function(card) {
      const cardDiscount = parseFloat(card.getAttribute("data-discount")) || 0;
      const cardBundleFactor = cardDiscount ? (1 - cardDiscount / 100) : 1;
      const cardPriceFactor = isAboActive ? aboFactor : cardBundleFactor;
      const cardUnitPriceInCents = Math.round(baseUnitPriceCents * cardPriceFactor);
      const cardPriceElement = q(".nh-bqs__bundle-card-unit-price-value", card);

      if (cardPriceElement) {
        cardPriceElement.textContent = numberToPrice(cardUnitPriceInCents / 100);
      }
    });
  }

  function handlePriceUpdate() {
    if (!isPdpBundleBVariant()) return;

    poll(
      () => q(".sls-option-container") && q(`.nh-bqs__bundle-card.selected`),
      () => {
        const selectedCard = q(`.nh-bqs__bundle-card.selected`);
        if (!selectedCard) return;
        
        const quantity = parseInt(selectedCard.getAttribute("data-quantity")) || 1;
        const discount = selectedCard ? parseFloat(selectedCard.getAttribute("data-discount")) : 0;
        
        const einmaligeContainer = q(".sls-option-container:not([data-selling-plan-group])");
        const aboContainer = q(".sls-option-container[data-selling-plan-group]");
        
        const unitPriceElement = q(`.nh-bqs__bundle-card[data-quantity="1"] .nh-bqs__bundle-card-unit-price-value`);
        if (!unitPriceElement) return;
        
        const totalPriceContainer = q(".nh-bqs__total-price");
        const baseVariantCents = totalPriceContainer ? parseInt(totalPriceContainer.getAttribute("data-base-variant-unit-cents"), 10) : 0;
        const baseUnitPrice = baseVariantCents > 0 ? baseVariantCents / 100 : priceToNumber(unitPriceElement.textContent);
        updateBundleCardUnitPrices(baseUnitPrice, aboContainer);
        
        if (einmaligeContainer) {
          const originalPriceInCents = Math.round(baseUnitPrice * 100);
          const bundleFactor = discount ? (1 - discount / 100) : 1;
          const exactTotalInCents = originalPriceInCents * bundleFactor * quantity;
          const totalPrice = Math.ceil(exactTotalInCents) / 100;
          updateOptionPrice(einmaligeContainer, numberToPrice(totalPrice));
        }
        
        if (aboContainer) {
          const originalPriceInCents = Math.round(baseUnitPrice * 100);
          const unitPriceInCents = Math.round(originalPriceInCents * 0.85);
          const totalPrice = (unitPriceInCents * quantity) / 100;
          updateOptionPrice(aboContainer, numberToPrice(totalPrice));
        }
      }
    );
  }

  function toggleAboDropdown() {
    const level2Container = q(".sls-option-container.seal-table[data-selling-plan-group]");
    const aboRadio = q('.sls-option[type="radio"]', level2Container);
    const dropdown = q('.nh-pdp-bundle-cards__selling-plan-group-dropdown', level2Container);
    
    
    if (aboRadio && dropdown) {
      if (aboRadio.checked) {
        dropdown.style.display = 'flex';
      } else {
        dropdown.style.display = 'none';
      }
      syncSealsubsAccessibility();
      initDeliveryOptionsKeyboard();
      
      forceActiveBoxStyling();
      
      setTimeout(() => {
        changeTotal();
        changeDiscount();
        handlePriceUpdate();
      }, 100);
    } else {
    }
  }
  

  function forceActiveBoxStyling() {
    poll(
      () => qq('.sls-option-container').length > 0,
      () => {
        const allBoxes = qq('.sls-option-container');
        
        function applyGreenStyling(logOnce = false) {
          allBoxes.forEach(box => {
            const isActive = box.classList.contains('sls-active');
            
            if (isActive) {
              box.style.setProperty('border-radius', '12px', 'important');
              box.style.setProperty('border', '1px solid #65704C', 'important');
              box.style.setProperty('background', 'linear-gradient(#f7f0e854 0% 100%)', 'important');
              box.style.setProperty('box-shadow', 'none', 'important');
              box.style.setProperty('padding', '15px 13px', 'important');
            } else {
              box.style.setProperty('border', '1px solid #E5E5E5', 'important');
              box.style.setProperty('background', '#FFF', 'important');
              box.style.setProperty('box-shadow', 'none', 'important');
              box.style.setProperty('padding', '16px 14px', 'important');
            }
          });
          if (logOnce) {
          }
        }
        
        applyGreenStyling(true);
        
        const observer = new MutationObserver(function(mutations) {
          let classChanged = false;
          
          mutations.forEach(mutation => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
              classChanged = true;
            }
          });
          
          if (classChanged) {
            applyGreenStyling();
            updateInfoboxVisibility();
            syncSealsubsAccessibility();
            initDeliveryOptionsKeyboard();
            changeTotal();
            changeDiscount();
            handlePriceUpdate();
          }
        });
        
        allBoxes.forEach(box => {
          observer.observe(box, {
            attributes: true,
            attributeFilter: ['class']
          });
        });
      }
    );
  }

  function changeText() {
    poll(
      () => q(".sls-option-container.seal-table .sls-selling-plan-group-first-line .sls-selling-plan-group-name"),
      () => {
        const level1 = q(".sls-option-container.seal-table:not([data-selling-plan-group]) .sls-selling-plan-group-first-line .sls-selling-plan-group-name");
        const level2 = q(".sls-option-container.seal-table[data-selling-plan-group] .sls-selling-plan-group-first-line .sls-selling-plan-group-name");
        const level2Container = q(".sls-option-container.seal-table[data-selling-plan-group]");
        
        const markup1 = `<div class="nh-pdp-bundle-cards__selling-plan-group-first-line">
          <span class="nh-pdp-bundle-cards__selling-plan-group-title">Einmalige Lieferung 
          <span class="nh-pdp-bundle-cards__selling-plan-group-subtitle">Keine Verpflichtung, jederzeit nachbestellbar</span></span>  
        </div>`;
        
        const discountValue = level2Container?.getAttribute('data-discount') || '15';
        const markup2 = `<div class="nh-pdp-bundle-cards__selling-plan-group-second-line">
          <span class="nh-pdp-bundle-cards__selling-plan-group-title">Abo-Lieferung <span data-discount="${discountValue}" class="nh-pdp-bundle-cards__selling-plan-group-percentage">-${discountValue}%</span></span>
          <span class="nh-pdp-bundle-cards__selling-plan-group-subtitle">Automatische Lieferung alle 4 Wochen</span>
        </div>`;
        
        if (level1) {
          changeHTML(level1, markup1);
        }
        
        if (level2) {
          changeHTML(level2, markup2);
        }
        
        if (level2Container && !q('.nh-pdp-bundle-cards__selling-plan-group-dropdown', level2Container)) {
          const dropdownMarkup = `<div class="nh-pdp-bundle-cards__selling-plan-group-dropdown" style="display: none;">
          <p>Das Abonnement kannst du jederzeit pausieren oder beenden</p>
          <p>Es gibt keine Mindestlaufzeit</p>
          <p>Zahlungen werden monatlich von deiner ausgewählten Zahlungsart abgebucht</p>
        </div>`;
          level2Container.insertAdjacentHTML('beforeend', dropdownMarkup);
        }
        
        const aboRadio = q('.sls-option[type="radio"]', level2Container);
        if (aboRadio) {
          aboRadio.addEventListener('change', toggleAboDropdown);
        }
        
        const allRadios = qq('.sls-option[type="radio"]');
        allRadios.forEach(radio => {
          radio.addEventListener('change', toggleAboDropdown);
        });
        syncSealsubsAccessibility();
        syncDeliveryLabelAccessibility();
        initDeliveryOptionsKeyboard();
        revealSealsubsWrapper();
      }
    );
  }

  function addAboInfobox() {
    poll(
      () => qq('.sls-option-container').length >= 2,
      () => {
        const allContainers = qq('.sls-option-container');
        
        allContainers.forEach((container, index) => {
          const sellingPlanGroup = container.getAttribute('data-selling-plan-group');
          const hasOneTimeRadio = container.querySelector('[data-one-time-option-radio]');
          const hasSellingPlanOptions = container.querySelector('.sls-selling-plan-group-options');
          const textContent = container.textContent || '';
          const isAboByText = textContent.includes('Abo') || textContent.includes('Lieferung alle');
          
        });
        
        let aboContainer = null;
        
        if (allContainers.length >= 2) {
          aboContainer = allContainers[1];
        }
        
        if (!aboContainer) {
          allContainers.forEach((container, index) => {
            const sellingPlanGroup = container.getAttribute('data-selling-plan-group');
            if (sellingPlanGroup && sellingPlanGroup !== "0" && parseInt(sellingPlanGroup) > 0) {
              aboContainer = container;
            }
          });
        }
        
        if (!aboContainer) {
          aboContainer = q('.sls-option-container.seal-table .sls-selling-plan-group-options')?.closest('.sls-option-container');
          if (aboContainer) {
          }
        }
        
        if (!aboContainer) {
          return;
        }
        
        if (aboContainer.querySelector('.nh-pdp-bundle-cards__abo-infobox')) {
          updateInfoboxVisibility();
          return;
        }
        
        const infoboxHTML = `
          <div class="nh-pdp-bundle-cards__abo-infobox" style="display: none;">
            <div class="nh-pdp-bundle-cards__abo-infobox-item">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span>Das Abonnement kannst du jederzeit pausieren oder beenden</span>
            </div>
            <div class="nh-pdp-bundle-cards__abo-infobox-item">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span>Es gibt keine Mindestlaufzeit</span>
            </div>
            <div class="nh-pdp-bundle-cards__abo-infobox-item">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span>Zahlungen werden monatlich von deiner ausgewählten Zahlungsart abgebucht</span>
            </div>
          </div>
        `;
        
        aboContainer.insertAdjacentHTML('beforeend', infoboxHTML);
        
        updateInfoboxVisibility();
        
        const observer = new MutationObserver(function(mutations) {
          mutations.forEach(mutation => {
            if (mutation.attributeName === 'class') {
              updateInfoboxVisibility();
            }
          });
        });
        
        allContainers.forEach(container => {
          observer.observe(container, { attributes: true, attributeFilter: ['class'] });
        });
        
      }
    );
  }
  
  function updateInfoboxVisibility() {
    const infobox = q('.nh-pdp-bundle-cards__abo-infobox');
    if (!infobox) return;
    
    const parentContainer = infobox.closest('.sls-option-container');
    if (!parentContainer) return;
    
    const isActive = parentContainer.classList.contains('sls-active');
    
    if (isActive) {
      infobox.style.display = 'flex';
    } else {
      infobox.style.display = 'none';
    }
    syncSealsubsAccessibility();
    initDeliveryOptionsKeyboard();
  }

  function hideMoreInfoContainer() {
    poll(
      () => q('.sls-more-info-container') || q('.sls-selling-plan-group-options') || q('.sls-total-price'),
      () => {
        const moreInfoContainers = qq('.sls-more-info-container');
        moreInfoContainers.forEach(container => {
          if (container && container.style.display !== 'none') {
            container.style.display = 'none';
          }
        });
        
        const sellingPlanOptions = qq('.sls-selling-plan-group-options');
        sellingPlanOptions.forEach(container => {
          if (container && container.style.display !== 'none') {
            container.style.display = 'none';
          }
        });
        
        if (!isPdpBundleBVariant()) {
          const priceContainers = qq('.sls-total-price, .sls-selling-plan-group-price, .sls-price-container');
          priceContainers.forEach(container => {
            if (container) {
              container.style.display = 'none';
              container.style.visibility = 'hidden';
              container.style.height = '0';
              container.style.width = '0';
              container.style.overflow = 'hidden';
              container.style.position = 'absolute';
              container.style.left = '-9999px';
            }
          });
        }

        syncSealsubsAccessibility();
        initDeliveryOptionsKeyboard();
      }
    );
  }

  function wrapSealsubsInSection() {
    poll(
      () => qq('.sealsubs-container').length > 0,
      () => {
        const allSealsubsContainers = qq('.sealsubs-container');
        const targetWrapper = q('.nh-pdp-bundle-cards__sealsubs-wrapper');
        
        
        let visibleContainer = null;
        
        allSealsubsContainers.forEach((container, index) => {
          const isInOurWrapper = targetWrapper && targetWrapper.contains(container);
          
          if (isInOurWrapper && !visibleContainer) {
            container.classList.remove('nh-pdp-bundle-cards__hidden-widget');
            setHiddenTree(container, false);
            visibleContainer = container;
          } else if (!visibleContainer) {
            container.classList.remove('nh-pdp-bundle-cards__hidden-widget');
            setHiddenTree(container, false);
            visibleContainer = container;
          } else {
            container.classList.add('nh-pdp-bundle-cards__hidden-widget');
            setHiddenTree(container, true);
          }
        });
        
        if (visibleContainer) {
          
          setTimeout(() => {
            changeText();
            hideMoreInfoContainer();
            addAboInfobox();
            forceActiveBoxStyling();
            toggleAboDropdown();
            syncSealsubsAccessibility();
            syncDeliveryLabelAccessibility();
            initDeliveryOptionsKeyboard();
            revealSealsubsWhenCustomized();
          }, 100);
        }
      }
    );
  }

  function handleMutation() {
    poll(
      () => ensureQuantityInput(),
      (base) => {
        const targetNode = base;
        const config = { attributes: true, attributeFilter: ['value'] };
        const callback = (mutationsList) => {
          for (const mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
              changeTotal();
              changeDiscount();
            }
          }
        };
        
        const observer = new MutationObserver(callback);
        observer.observe(targetNode, config);
      }
    );
  }

  function handleMutationForLieferung() {
    poll(
      () => q(`.sls-purchase-options-container`),
      (base) => {
        const targetNode = base;
        const config = { 
          childList: true, 
          attributes: true, 
          subtree: true
        };
        
        const callback = (mutationsList) => {
          changeTotal();
          changeDiscount();
        };
        
        const observer = new MutationObserver(callback);
        observer.observe(targetNode, config);
      }
    );
  }

  function handleClick() {
    poll(
      () => q("body"),
      () => {
        const productForm = q(".product-single__form, form[action*='/cart/add'], .product-form, [data-product-form]");
        
        if (productForm) {
          productForm.addEventListener('submit', function(e) {
            
            const selectedCard = q(".nh-bqs__bundle-card.selected");
            if (selectedCard) {
              const quantity = selectedCard.getAttribute('data-quantity') || '1';
              
              const productQuantityInput = ensureQuantityInput();
              if (productQuantityInput) {
                productQuantityInput.value = quantity;
              }
              
              const formQuantityInputs = qq('input[name="quantity"]', productForm);
              
              formQuantityInputs.forEach(function(input) {
                input.value = quantity;
              });
              
              const allQuantityInputs = qq('input[name="quantity"]');
              allQuantityInputs.forEach(function(input) {
                input.value = quantity;
              });
            }
          }, true);
          
        } else {
          
          document.addEventListener('submit', function(e) {
            const form = e.target;
            if (form.action && form.action.includes('/cart/add')) {
              
              const selectedCard = q(".nh-bqs__bundle-card.selected");
              if (selectedCard) {
                const quantity = selectedCard.getAttribute('data-quantity') || '1';
                
                const productQuantityInput = ensureQuantityInput();
                if (productQuantityInput) {
                  productQuantityInput.value = quantity;
                }
                
                qq('input[name="quantity"]', form).forEach(function(input) {
                  input.value = quantity;
                });
                
              }
            }
          }, true);
        }
        
        q("body").addEventListener("click", (e) => {
          if (e.target.closest(`.nh-bqs__btn`)) {
            q(".product-single__form button").click();
          }
        });
      }
    );
  }

  function mainJS() {
    wrapSealsubsInSection();
    initBundleCardsHandlers();
    handleMutation();
    handleMutationForLieferung();
    handleClick();
    hideMoreInfoContainer();
    syncSealsubsAccessibility();
    syncDeliveryLabelAccessibility();
    initDeliveryOptionsKeyboard();
    revealSealsubsWhenCustomized();
    setTimeout(function() {
      handlePriceUpdate();
      changeTotal();
      changeDiscount();
      forceActiveBoxStyling();
      toggleAboDropdown();
      syncSealsubsAccessibility();
      syncDeliveryLabelAccessibility();
      initDeliveryOptionsKeyboard();
      revealSealsubsWhenCustomized();
    }, 200);

    setTimeout(function() {
      changeTotal();
      changeDiscount();
      syncSealsubsAccessibility();
      initDeliveryOptionsKeyboard();
    }, 650);

    setTimeout(function() {
      changeTotal();
      changeDiscount();
      syncSealsubsAccessibility();
      initDeliveryOptionsKeyboard();
    }, 1400);
    
    document.addEventListener('shopify:section:load', function(event) {
      if (event.target.querySelector('.nh-bqs__bundle-card') || 
          event.target.querySelector('.nh-pdp-bundle-cards__bundle-cards-wrapper') ||
          event.target.querySelector('.nh-pdp-bundle-cards__sealsubs-wrapper')) {
        setTimeout(function() {
          wrapSealsubsInSection();
          initBundleCardsHandlers();
          forceActiveBoxStyling();
          initDeliveryOptionsKeyboard();
        }, 100);
      }
    });
  }

  function initWhenReady() {
    const hasBundleCards = document.querySelector('.nh-pdp-bundle-cards__bundle-cards-wrapper');
    const hasSealSubsWrapper = document.querySelector('.nh-pdp-bundle-cards__sealsubs-wrapper');
    
    if (hasBundleCards || hasSealSubsWrapper) {
      mainJS();
    } else {
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWhenReady);
  } else {
    initWhenReady();
  }
})();
